import { Pipe, PipeTransform } from '@angular/core';

import { HumanService } from 'src/app/shared/services/human.service';

@Pipe({
  name: 'title',
})
export class TitlePipe implements PipeTransform {
  constructor(private humanService: HumanService) { }

  transform(value: any): any {
    return this.humanService.fieldToTitle(value);
  }
}
